export type DateInterval = "year" | "quarter" | "month" | "week" | "day" | "hour" | "minute" | "second";

export function fixUrlTrailingSlash(url: string): string {
    url = url.trim();
    if (url.length === 0 || url[url.length-1] === "/")
        return url;
    return url + "/";
}

/**
 * Adds the given units of interval to the date.
 * It returns a copy of the date, so the given date is not modified.
 * @param date
 * @param interval
 * @param units
 */
export function dateAdd(date: Date, interval: DateInterval, units: number): Date {
    let ret = new Date(date); //don't change original date
    switch (interval.toLowerCase()) {
        case 'year'   :  ret.setFullYear(ret.getFullYear() + units);  	break;
        case 'quarter':  ret.setMonth(ret.getMonth() + 3*units);  		break;
        case 'month'  :  ret.setMonth(ret.getMonth() + units);  		    break;
        case 'week'   :  ret.setDate(ret.getDate() + 7*units);  		        break;
        case 'day'    :  ret.setDate(ret.getDate() + units);  			        break;
        case 'hour'   :  ret.setTime(ret.getTime() + units*3600000);  	        break;
        case 'minute' :  ret.setTime(ret.getTime() + units*60000);  	        break;
        case 'second' :  ret.setTime(ret.getTime() + units*1000);  		        break;
        default       :  ret = undefined;  break;
    }
    return ret;
}

export function assertUnreachableCode(x: never): never {
    throw new Error("Unexpected object: " + x);
}

export function toDisplayTimeHHMMSS(secondsTotal: number, forceHours: boolean = false): string {
    const hours = Math.floor(secondsTotal / 3600);
    const minutes = Math.floor((secondsTotal - (hours * 3600)) / 60);
    const seconds = secondsTotal - (hours * 3600) - (minutes * 60);

    let timeStr = "";
    if (hours !== 0 || forceHours === true) {
        if (hours < 10)
            timeStr += "0";
        timeStr += hours + ":";
    }
    if (minutes < 10)
        timeStr += "0";
    timeStr += minutes + ":";
    if (seconds < 10)
        timeStr += "0";
    timeStr += seconds;
    return timeStr;
}

export interface GetBetweenOptions {
    startPos?: number;
    prestartTxt?: string;
    caseInsensitive?: boolean;
}

export function getBetween(text: string, startTxt: string, endTxt: string, options: GetBetweenOptions = {}): string | false {
    options.startPos = typeof options.startPos === 'number' ? options.startPos : 0
    let preStart = typeof options.prestartTxt === 'string' && options.prestartTxt !== ''
    let searchText = options.caseInsensitive === true ? text.toLocaleLowerCase() : text
    if (options.caseInsensitive === true) {
        if (preStart)
            options.prestartTxt = options.prestartTxt.toLocaleLowerCase()
        startTxt = startTxt.toLocaleLowerCase()
        endTxt = endTxt.toLocaleLowerCase()
    }
    if (preStart) {
        options.startPos = searchText.indexOf(options.prestartTxt, options.startPos)
        if (options.startPos === -1)
            return false
        options.startPos += options.prestartTxt.length
    }
    options.startPos = searchText.indexOf(startTxt, options.startPos)
    if (options.startPos === -1)
        return false
    options.startPos += startTxt.length
    let endPos = searchText.indexOf(endTxt, options.startPos)
    if (endPos === -1)
        return false
    return text.substr(options.startPos, endPos-options.startPos)
}

export function format(string: string, ...args: string[]): string {
    let start = 0;
    for (let i = 1; i < arguments.length; i++)
    {
        let search = "%" + i;
        start = string.indexOf(search, start);
        if (start === -1)
            break;
        start += 2;
        string = string.replace(search, arguments[i]);
    }
    return string;
}
